import { GetStaticProps } from 'next';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { ReactElement } from 'react';

import { Authenticate } from '@/modules';
import { IAuthTypes } from '@/modules/auth/context';
import { Layout } from '@/shared/hocs';

export default function LoginPage(): ReactElement {
  const { t } = useTranslation('login');

  const seoData = {
    templateTitle: t('login'),
  };

  return (
    <Layout
      withContainer={false}
      withSideMenu={false}
      withHeader={false}
      seoData={seoData}
      bgColor='white'
    >
      <Authenticate authType={IAuthTypes.login} />
    </Layout>
  );
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale as string)),
      // Will be passed to the page component as props
    },
  };
};
